import { createThemeBuilder } from '@tamagui/theme-builder';

import { componentThemeDefinitions } from './componentThemeDefinitions';
import { masks } from './masks';
import { palettes } from './palettes';
import { shadows } from './shadows';
import { maskOptions, templates } from './templates';
import {
    colorPrimitiveTokens,
    darkColorPrimitiveTokens,
} from '../../themes/SmoothieColorTokens';

const themesBuilder = createThemeBuilder()
    .addPalettes(palettes)
    .addTemplates(templates)
    .addMasks(masks)
    .addThemes({
        light: {
            template: 'base',
            palette: 'light',
            nonInheritedValues: {
                ...colorPrimitiveTokens,
                ...shadows.light,
            },
        },
        dark: {
            template: 'base',
            palette: 'dark',
            nonInheritedValues: {
                ...darkColorPrimitiveTokens,
                ...shadows.dark,
            },
        },
    })
    .addChildThemes({
        alt1: {
            mask: 'soften',
            ...maskOptions.alt,
        },
        alt2: {
            mask: 'soften2',
            ...maskOptions.alt,
        },
        active: {
            mask: 'soften3',
            skip: {
                color: 1,
            },
        },
    })
    .addChildThemes(componentThemeDefinitions, {
        // to save bundle size but make alt themes not work on components
        // avoidNestingWithin: ['alt1', 'alt2'],
    });

export const themes = themesBuilder.build();
